
// Vue
import { Component, Vue, Prop, Mixins, Watch } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";

import { AudioDevice, AudioOptions, AudioTypes, DeviceSpec } from "@/types/audio/audio";
import AudioMixin, { SvAudioContext } from "@/mixins/audio/AudioMixin";

@Component({})
export default class IntercomAudioReceive extends Mixins(AudioMixin) {
    // -- Props -- //

    @Prop({ default: null, type: Object }) audioReceive: AudioDevice;
    @Prop({ default: "", type: String }) address: string;

    // -- Properties -- //

    private active: boolean = false;

    // -- Lifecycle Hooks -- //

    public mounted() {
        this.setAudio();
    }

    // -- Computed properties -- //

    /**
     * @summary computed property which will return the varient state of the button
     * @returns { string } 'primary' or 'secondary'
     */
    private get currentVariant() {
        if (!this.getAuthState) return "warning";
        return this.active ? "primary" : "secondary";
    }

    // -- Watchers -- //

    @Watch("active")
    private async setListenState(state: boolean) {
        await this.listenAudio(state);
    }

    @Watch("address")
    private addressChange(newAddress: string) {
        this.active = false;
        this.setAudio();
    }

    // -- Methods -- //

    /**
     * @summary method to toggle the active state for receive.
     */
    private toggleActiveState() {
        this.active = !this.active;
    }

    /**
     * @summary method which will setup the audio instance
     */
    private setAudio() {
        if (!this.address) return;
       const audioContext: SvAudioContext = {
           url: this.address,
           playingState: this.active
       }
       this.setupAudio(audioContext);
    }
}
